<script context="module">
  import { formatDate } from '/helper'

  export function datesToString(start, end) {
    const startDate = new Date(start)
    const endDate = new Date(end)
    const startString = formatDate(startDate, 'event-day-month-year')
    const endString   = formatDate(endDate, 'event-day-month-year')
    if (startString === endString) {
      if (startDate.getTime()  === endDate.getTime()) {
        // start time equals end time
        return startString
      } else {
        // same day, but start time is different to end time
        return startString + " " + formatDate(startDate, 'time24') + "–" + formatDate(endDate, 'time24')
      }
    } else {
      return [formatDate(startDate, 'event-day-month'), endString].join(" – ")
    }
  }

</script>

<script>

  export let startDate, endDate, overrideString = null

</script>

<span>
  { overrideString || datesToString(startDate, endDate) }
</span>
